import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import {
  FluorescenceCaptureProperty,
  UltravioletCaptureProperty,
  VisibleCaptureProperty,
} from "../../../Model/CaptureProfile";
import { ObjectiveZoom } from "../../../Model/ImagerCapabilities";
import { BasicSelectionControl } from "../ImagerFeatureControls";

type ObjectiveControlProps = {
  disabled: boolean;
  objectiveZoom: ObjectiveZoom;
  captureProperty: VisibleCaptureProperty | FluorescenceCaptureProperty | UltravioletCaptureProperty;
  onChange: (value: { objectiveZoom: number }) => void;
};

export function ObjectiveZoomControl({ objectiveZoom, captureProperty, disabled, onChange }: ObjectiveControlProps) {
  const displayValues = objectiveZoom.objectives.map((objective) => ({
    display: objective.name,
    value: objective.value.toString(),
  }));

  if (captureProperty.objectiveZoom == null) {
    throw new Error("Capture profile objective zoom is null");
  }

  return (
    <BasicSelectionControl
      disabled={disabled}
      feature="Objective"
      id={EOpticAndCameraFeature.ObjectiveZoom}
      displayValues={displayValues}
      value={captureProperty.objectiveZoom.toString()}
      onValueChanged={(id, value) =>
        onChange({
          objectiveZoom: Number.parseFloat(value),
        })
      }
    />
  );
}
